import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const PedidosVentaApi = {
  getPedidosComisiones: async (empresa, year) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_URL}/api/pedidosVenta/${empresa}/pedidos_comisiones`,
      {
        params: { year },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data;
  },

  getPedidosComisionesReducido: async (empresa, year) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_URL}/api/pedidosVenta/${empresa}/pedidos_comisiones_reducido`,
      {
        params: { year },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data;
  },

  getPedidosVentasIrene: async (empresa, year) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_URL}/api/pedidosVenta/${empresa}/pedidos_ventas_irene`,
      {
        params: { year },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data;
  },

  getRankingVentas: async (empresa, year) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_URL}/api/pedidosVenta/${empresa}/ranking_ventas`,
      {
        params: { year },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data;
  },
};
